/**
 * タグでメンバーを並び替える
 * - タグがある人が優先
 * - tag1 → tag2 の順で比較
 * - tag1がある人がtag1のない人より優先
 * @param {Array} members
 * @param {'asc' | 'desc'} sortOrder
 * @returns {Array}
 */
export function sortMembersByTag(members, sortOrder) {
  return [...members].sort((a, b) => {
    const aTag1 = a.tag1 ?? ''
    const aTag2 = `${a.tag2 ?? ''}`
    const bTag1 = b.tag1 ?? ''
    const bTag2 = `${b.tag2 ?? ''}`

    const aHasTag = aTag1 !== '' || aTag2 !== ''
    const bHasTag = bTag1 !== '' || bTag2 !== ''

    // タグなしは末尾
    if (aHasTag !== bHasTag) return aHasTag ? -1 : 1

    // tag1優先: tag1がある人がtag1のない人より先
    if (aTag1 !== bTag1) {
      if (aTag1 === '') return 1
      if (bTag1 === '') return -1
      const cmp = aTag1.localeCompare(bTag1, 'ja')
      return sortOrder === 'asc' ? cmp : -cmp
    }

    // tag2で比較（数値順）
    const tag2Cmp = aTag2.localeCompare(bTag2, 'ja', { numeric: true })
    return sortOrder === 'asc' ? tag2Cmp : -tag2Cmp
  })
}
